module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1037-4f72a717e6bbd8f9042df6727c26a380.png";